<template>
  <transition name="fade-bottom" @after-leave="destroy">
    <div
      v-show="show"
      :style="{ top: `${top}px` }"
      class="msg msg-fixed"
      :class="[`msg-${type}`]"
      @mouseleave="startTimer"
      @mouseenter="clearTimer"
    >
      <span><lp-icon class="mr-half" :name="type" /></span>
      {{ text }}
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import LpIcon from '../icon/LpIcon.vue'

export default defineComponent({
  name: 'msg',
  components: {
    LpIcon,
  },
  data() {
    return {
      id: null,
      show: false,
      text: '',
      duration: 4000,
      onClose: () => {},
      top: 6,
      type: 'info',
      timer: null as unknown as NodeJS.Timeout,
    }
  },
  mounted() {
    this.show ? null : this.startTimer()
  },
  methods: {
    destroy() {
      this.$el.parentNode!.removeChild(this.$el)
    },

    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.show = false
          if (this.onClose) {
            this.onClose()
          }
        }, this.duration)
      }
    },

    clearTimer() {
      clearTimeout(this.timer!)
    },
  },
})
</script>
